import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Sparte } from '@mwe/models';
import { ProductIconComponent } from '../../product-icon/product-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-clickable-products-card',
  templateUrl: 'clickable-products-card.component.html',
  imports: [ProductIconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClickableProductsCardComponent {
  cardClicked = output();
  categories = input<Sparte[]>();
  ariaTitle = input<string>();
  dataTest = input<string>();
  hasAutoFocus = input<boolean>(false);
}
